export default __webpack_public_path__ + "landingPage1.html";